import { render, staticRenderFns } from "./WalletLessNotificaion.vue?vue&type=template&id=001cf750&"
import script from "./WalletLessNotificaion.vue?vue&type=script&lang=js&"
export * from "./WalletLessNotificaion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports